export class HardwareDevice{
  constructor(
    public hardwareDeviceId: string,
    public sergasCode: string,
    public serialNumber: string,
    public model: string,
    public provider: string,
    public installedDate: Date,
    public created: Date,
    public createdBy: string,
    public modified: Date,
    public modifiedBy: string,
    public sergasDeviceId: string
  ){}
}
